
import Vue from "vue";
import axios from "axios";
import { hideNonProfessorStaffLists } from "@/config/staffDisplay";
import ProgressiveImage from "@/components/ProgressiveImage.vue";
import { prefetchStaffPhotoThumbs } from "@/utils/staffPhoto";

export default Vue.extend({
  components: { ProgressiveImage },
  props: ["post"],
  data: () => ({
    type: "" as any,
    students: [] as any,
    directions: [
      "默认方向", "语音增强", "语音识别", "语音合成", "声纹识别", "多模态交互",
    ],
    types: {
      doctor: "博士研究生",
      postgraduate: "硕士研究生",
      undergraduates: "本科",
      graduated: "毕业学生",
      visitor: "访问学者",
    } as any,
  }),
  mounted() {
    this.type = this.$route.name ? this.types[this.$route.name] : "博士研究生";
    this.getStudentList();
  },
  methods: {
    getStudentList() {
      if (hideNonProfessorStaffLists) {
        this.students = [];
        return;
      }
      axios
        .post(Vue.prototype.apiUrl("get-item-list-need"), {
          collection: "staff",
          need: { type: this.type },
        })
        .then(async (response) => {
          this.students = response.data;
          this.students.sort((a: any, b: any) =>
            parseInt(a.grade, 10) < parseInt(b.grade, 10) ? -1 : 1
          );
          await prefetchStaffPhotoThumbs(this.students);
        });
    },
    gotoStudent(engName: string) {
      this.$router.push({ path: `/staff/${this.$route.name}/${engName}` });
    },
  },
});
